"use strict";

PF.ButtonSubmit = class ButtonSubmit extends PF.Widget
	{
	static get options()
		{
		return {
			dom: {
				element: undefined,
				wrapper: undefined
			},
			html: PF.ButtonSubmit.templates,
			// text: "Принять",
			errorPointer: undefined,
			error: "",
			enabled: true
		};
		}

	static get templates()
		{
		return {
			wrapper: `
				<div class="pf-button-submit-wrapper" pf="wrapper">
				</div>
				`,
			buttonContent: `
				<!--<div class="button-submit-container">-->
					<a href="#" class="button button-fill" pf="button"></a>
					<div class="error" pf="error">&nbsp;</div>
				<!--</div>-->
				`,
		};
		}

	init()
		{
		super.init();
		this.dom.loads(this.html);

		this.dom.wrapper.append(this.dom.buttonContent);
		this.dom.element.after(this.dom.wrapper);
		this.dom.button.after(this.dom.element);
		this.dom.button.remove();
		// this.dom.button.replaceWith(this.dom.element);
		this.dom.button = this.dom.element;

		if (this.errorPointer !== undefined)
			{
			this.calc('error', this.errorPointer);
			}

		// this.calc('disabledAttr', 'disabled', (d) => d === true ? 'disabled' : 'false');
		// this.bindDom({element: 'enabled'}, 'enabled');
		// this.bindNode('enabled', this.dom.element, MK.binders.enabled());
		this.calc('dom.element.enabled', 'enabled');

		this.bindDom({wrapper: 'class:error'}, 'error', (e) => e !== '');
		this.bindDom({error: 'html'}, ['helper', 'error'], (h, e) => e !== '' ? e : '&nbsp;');


		// this.calc('errorState', 'error', (error = '') => error.length > 0);
		// this.calc('errorHtml', 'error', (error = '') => error.length > 0 ? error : '&nbsp;');
		//
		// this.bindNode('errorState', this.dom.wrapper, MK.binders.className('error'));
		// this.bindNode('errorHtml', this.dom.error, MK.binders.html());
		this.dom.button.on('click', () => this.trigger('submit'));
		}
	};





